// Hook podsumowania wartości oferty – GET /sales-crm/clients/:id/offers/:offerId/totals

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmOfferTotals {
  productNet: number;
  productGross: number;
  shippingNet: number;
  shippingGross: number;
  totalNet: number;
  vat: number;
  totalGross: number;
  marginNet: number | null;
  marginPct: number | null;
  positionsCount: number;
  clientCreditLimitRemaining: number | null;
}

export const getSalesCrmOfferTotalsQueryKey = (
  clientId: number,
  offerId: string,
  versionId?: number | null
) =>
  ['sales-crm', 'client', clientId, 'offer', offerId, 'totals', versionId ?? 'actual'] as const;

const getSalesCrmOfferTotals = (
  clientId: number,
  offerId: string,
  versionId?: number | null
): Promise<ISalesCrmOfferTotals> =>
  axios.get(`/sales-crm/clients/${clientId}/offers/${offerId}/totals`, {
    params: versionId ? { versionId } : undefined
  });

export const useGetSalesCrmOfferTotals = (
  clientId: number,
  offerId: string,
  versionId?: number | null,
  options?: UseQueryOptions<ISalesCrmOfferTotals, IError>
) =>
  useQuery<ISalesCrmOfferTotals, IError>(
    getSalesCrmOfferTotalsQueryKey(clientId, offerId, versionId),
    () => getSalesCrmOfferTotals(clientId, offerId, versionId),
    {
      ...options,
      enabled:
        options?.enabled !== false && clientId > 0 && String(offerId).trim().length > 0
    }
  );
